<template>
    <div v-if="errorMessage != null" class="errorMessageOverlay"> {{ computedMessage }} </div>
</template>

<script>
  export default {
    name: 'errorMessageOverlay',
    props: ['errorMessage'],
    components: {},

    computed: {
      computedMessage(){
        if(this.errorMessage){
          return this.errorMessage
        } if(this.errorMessage == ""){
          return "Fehler oder fehlendes Ergebnis"
        }
      }
    }
  }
</script>

<style lang="sass">
  .errorMessageOverlay
    position: absolute
    background-color: white
    border-radius: 1px
    max-width: 300px
    top: 50%
    left: 50%
    transform: translate(-50%, -50%)
    box-shadow: 0 8px 16px 0 rgba(0,0,0,0.2)
    z-index: 2
    padding: 5px 10px 5px 10px
</style>
